import { EndFreeSpinsPopupComponent, EndFreeSpinsPopupView } from '@cgs/machines';
import { SantaEndFreeSpinsPopupController } from './santa-end-free-spins-popup.controller';

export class SantaEndFreeSpinsPopupComponent extends EndFreeSpinsPopupComponent {
  protected createComponents() {
    this._view = new EndFreeSpinsPopupView(
      this.container,
      this.rootScene,
      this.popupScene,
      this.params
    );
    this.popupController = new SantaEndFreeSpinsPopupController(
      this.container,
      this._view,
      this.params
    );
  }
}
